<template>
  <div class="container">
    <div v-if="dataLoading" class="loading">
      <svg
        width="38"
        height="38"
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
        stroke="#000"
      >
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(1 1)" stroke-width="2">
            <circle stroke-opacity="0.5" cx="18" cy="18" r="18" />
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 18 18"
                to="360 18 18"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </g>
        </g>
      </svg>
      <div class="loading-status">{{ loadingStatus }}</div>
    </div>
    <template v-else>
      <div class="header">
        <slot name="header"></slot>
      </div>
      <div class="left-column">
        <slot name="left-column"></slot>
      </div>
      <div class="right-column">
        <slot name="right-column"></slot>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
    ...mapState([
      'dataLoading',
      'loadingStatus'
    ])
  },
  }
</script>

<style lang="scss" scoped>
  @mixin scrollable-container {
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .loading {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 20;
    background: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: rgb(255, 102, 0);
  }
  .container {
    display: grid;
    grid-template-rows: 60px 1fr;
    grid-template-columns: 1fr 1fr;
    height: 100%;
  }
  .loading-status {
    margin-top: 20px;
  }
  .header {
    grid-row: 1/2;
    grid-column: 1/3;
    display: flex;
    align-items: center;
    padding: 0 40px;
    border-bottom: 1px solid #e6e6e6;
    // box-shadow: 0px 1px 10px rgba(0,0,0,0.1);
    z-index: 1;
  }
  .left-column {
    @include scrollable-container;
    grid-row: 2/3;
    grid-column: 1/2;
    // overflow-y: scroll;
    padding: 0 40px 40px;
  }
  .right-column {
    grid-row: 2/3;
    grid-column: 2/3;
  }
</style>